<h1 class="page-header">
  {{ pageMainTitle }} <small *ngIf="pageSubTitle">{{ pageSubTitle }}</small>
</h1>
